import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, UserRound, Building2, Target, Clock, Gift } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DiscoveryForm from "@/components/DiscoveryForm";

const TOPICS = [
  [UserRound, "Vous", "Votre parcours, vos motivations et vos attentes pour l'après-cession."],
  [Building2, "Votre entreprise", "Son histoire, son activité, ses équipes, ses clients et ses atouts."],
  [Target, "Vos objectifs", "Calendrier, valorisation espérée, profil de repreneur idéal."],
];
const PROMISES = [[ShieldCheck, "100 % confidentiel"], [Gift, "Gratuit et sans engagement"], [Clock, "Environ 45 minutes"]];

export default function DiscoveryCall() {
  return (
    <div className="bg-[#FDFDFC]">
      <Header />
      <section className="bg-[#1B2A4A] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <span className="text-[#E0C173] uppercase tracking-[0.25em] text-xs font-medium">Cédants · Premier échange</span>
          <h1 data-testid="rdv-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white mt-4 max-w-3xl leading-tight">Demandez votre <span className="text-[#E0C173] italic">RDV découverte</span></h1>
          <p className="text-white/75 text-base md:text-lg mt-5 max-w-2xl">Un premier rendez-vous pour apprendre à vous connaître, comprendre votre entreprise et préparer la cession de votre affaire en toute discrétion.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            {PROMISES.map(([Ic, t]) => (
              <span key={t} className="inline-flex items-center gap-2 border border-white/20 text-white/90 text-sm px-4 py-2 rounded-full"><Ic className="w-4 h-4 text-[#E0C173]" strokeWidth={1.5} /> {t}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid lg:grid-cols-5 gap-12">
        <motion.aside initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="lg:col-span-2 space-y-8">
          <div>
            <h2 className="font-display text-lg font-semibold text-[#1B2A4A]">De quoi parle-t-on ?</h2>
            <ul className="mt-5 space-y-5">
              {TOPICS.map(([Ic, t, d]) => (
                <li key={t} className="flex gap-4">
                  <span className="w-11 h-11 shrink-0 rounded-xl bg-[#1B2A4A] flex items-center justify-center"><Ic className="w-5 h-5 text-[#E0C173]" strokeWidth={1.5} /></span>
                  <div><div className="font-semibold text-[#1B2A4A]">{t}</div><p className="text-sm text-[#475569] mt-0.5">{d}</p></div>
                </li>
              ))}
            </ul>
          </div>
          <blockquote className="border-l-2 border-[#E0C173] pl-5 text-[#475569] italic">« Céder son entreprise est souvent l'affaire d'une vie. Ce premier échange, en toute discrétion, pose les bases d'une transmission réussie. »<footer className="not-italic text-xs uppercase tracking-wider text-[#1B2A4A] mt-2">PROAC Transmission · 35 ans d'expérience</footer></blockquote>
          <p className="text-sm text-[#475569]">Vous préférez déposer directement votre annonce ? <Link to="/inscription?role=seller" data-testid="rdv-seller-signup" className="text-[#1B2A4A] font-medium border-b border-[#E0C173]">Créer un compte cédant</Link></p>
        </motion.aside>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="lg:col-span-3 bg-white border border-gray-200 p-6 sm:p-10 relative">
          <DiscoveryForm />
        </motion.div>
      </section>
      <Footer />
    </div>
  );
}
